import React, { useEffect } from 'react';
import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/redux';
import { AuthProvider } from '@/contexts/AuthContext';
import { logout, teamUserLogout } from '@/store/redux/slices/authSlice';
// import { NotificationProvider } from '../context/NotificationContext';

interface AppProvidersProps {
  children: ReactNode;
}

// Component to handle auth events
const AuthEventHandler: React.FC<{ children: ReactNode }> = ({ children }) => {
  useEffect(() => {
    const handleAuthLogout = () => {
      store.dispatch(logout());
    };

    const handleTeamUserLogout = () => {
      store.dispatch(teamUserLogout());
    };

    // Listen for auth logout events
    window.addEventListener('auth:logout', handleAuthLogout);
    window.addEventListener('auth:teamUserLogout', handleTeamUserLogout);

    return () => {
      window.removeEventListener('auth:logout', handleAuthLogout);
      window.removeEventListener('auth:teamUserLogout', handleTeamUserLogout);
    };
  }, []);

  return <>{children}</>;
};

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AuthEventHandler>
          {/* <NotificationProvider> */}
          {children}
          {/* </NotificationProvider> */}
        </AuthEventHandler>
      </AuthProvider>
    </Provider>
  );
};
